export default {
  'Teklif Formu': 'Formulaire de Devis',
  'Kayıtlı Teklifler': 'Devis Sauvegardés',
  'Kullanıcı Adı': 'Nom d\'Utilisateur',
  'Şifre': 'Mot de Passe',
  'Giriş Yap': 'Se Connecter',
  'Çıkış Yap': 'Se Déconnecter',
  'KDV Oranı': 'Taux de TVA',
  'Teklif Durumu': 'Statut du Devis',
  'Kaydet': 'Sauvegarder',
  'PDF Önizleme': 'Aperçu PDF',
  'PDF\'ye Aktar': 'Exporter en PDF',
  'E-posta ile Gönder': 'Envoyer par Email',
  'Alıcı': 'Destinataire',
  'Tarih': 'Date',
  'Genel Toplam': 'Total Général',
  'Not': 'Note',
  'KDV': 'TVA',
  'Alt Toplam': 'Sous-total',
  'Açıklama': 'Description',
  'Ürün Adı': 'Nom du Produit',
  'SUT Kodu': 'Code SUT',
  'Birim Alış Fiyatı': 'Prix Unitaire',
  'Sipariş Adedi': 'Quantité de Commande',
  'Promosyon Ürün': 'Produit Promotionnel',
  'Toplam Adet': 'Quantité Totale',
  'Sipariş Tutarı': 'Total de la Commande',
  'Durum': 'Statut',
  'Kabul Edildi': 'Accepté',
  'Reddedildi': 'Rejeté',
  'Gönderildi': 'Envoyé',
  'Taslak': 'Brouillon',
  'Yurtiçi': 'National',
  'Yurtdışı': 'International',
  'Sipariş Oluştur': 'Créer une Commande',
  'Ürün Sıralaması': 'Tri des Produits',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'Les produits sont triés par popularité et importance',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'Les produits de cardiologie et de chirurgie vasculaire sont affichés en priorité',
  'Ürün adı, açıklama veya barkod ile ara...': 'Rechercher par nom de produit, description ou code-barres...',
  'Tüm Kategoriler': 'Toutes les Catégories',
  'Kutu görünüm': 'Vue grille',
  'Liste görünüm': 'Vue liste',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Aucun produit trouvé correspondant à vos critères',
  'Ürün Adı Yok': 'Aucun Nom de Produit',
  'Kategori Yok': 'Aucune Catégorie',
  'Açıklama yok': 'Aucune description',
  'Firma Bilgilerini Doldurun': 'Remplir les Informations de l\'Entreprise',
  'Sepete Ekle': 'Ajouter au Panier',
  'Firma Bilgileri': 'Informations de l\'Entreprise',
  'Ülke Seçimi': 'Sélection du Pays',
  'Türkiye': 'Turquie',
  'Almanya': 'Allemagne',
  'ABD': 'États-Unis',
  'Firma Ünvanı': 'Nom de l\'Entreprise',
  'Vergi Dairesi': 'Bureau des Impôts',
  'Vergi Numarası': 'Numéro de Taxe',
  'Adres': 'Adresse',
  'Şehir': 'Ville',
  'Şehir Seçimi': 'Sélection de Ville',
  'Şehir Seçiniz': 'Sélectionner Ville',
  'Şehir adı ara...': 'Rechercher le nom de la ville...',
  'Aradığınız şehir bulunamadı': 'Ville non trouvée',
  'Bu ülke için şehir verisi bulunamadı': 'Aucune donnée de ville disponible pour ce pays',
  'şehir bulundu': '{{count}} villes trouvées',
  'Yetkili': 'Personne Autorisée',
  'Telefon': 'Téléphone',
  'Email': 'Email',
  'Bilgileri İlet': 'Envoyer les Informations',
  'Lütfen eksik alanları doldurun': 'Veuillez remplir les champs manquants',
  'Firma kaydedilemedi': 'L\'entreprise n\'a pas pu être sauvegardée',
  'Firma bilgileri başarıyla iletildi': 'Informations de l\'entreprise envoyées avec succès',
  'Firma Ünvanı:': 'Nom de l\'Entreprise:',
  'Yetkili Kişi:': 'Personne Autorisée:',
  'Sepetiniz': 'Votre Panier',
  'Sepetiniz boş': 'Votre panier est vide',
  'adet': 'pcs',
  'Düzenle': 'Modifier',
  'Kaldır': 'Supprimer',
  'Siparişi Tamamla': 'Finaliser la Commande',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Veuillez d\'abord envoyer les informations complètes de votre entreprise',
  'Sipariş başarıyla kaydedildi': 'Commande sauvegardée avec succès',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Message de bienvenue et lien d\'accès envoyés à votre email',
  'Link 3 gün geçerlidir': 'Le lien est valide pendant 3 jours',
  'Sipariş kaydedilemedi': 'La commande n\'a pas pu être sauvegardée',
  'Firma Bilgileri Gerekli': 'Informations d\'Entreprise Requises',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Remplissez d\'abord les informations de l\'entreprise pour ajouter au panier',
  'Önce Bilgileri Doldurun': 'Remplissez d\'abord les Informations',
  'Uyarı': 'Avertissement',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Vous devez d\'abord remplir les informations de l\'entreprise pour ajouter au panier',
  'SUT Kütüphanesi Tanımı': 'Définition de la Bibliothèque SUT',
  'SUT Kodu:': 'Code SUT:',
  'Standart': 'Standard',
  'Açıklama (isteğe bağlı)': 'Description (optionnel)',
  'Partner Ol': 'Devenir Partenaire',
  'Partner başvuru popup açılacak': 'Le popup de candidature partenaire s\'ouvrira',
  'Dil': 'Langue',
  'E-posta': 'Email',
  'E-Posta': 'Email',
  'Şifre': 'Mot de Passe',
  'Şifremi Unuttum': 'Mot de Passe Oublié',
  'Giriş yapılıyor...': 'Connexion en cours...',
  'E-posta veya şifre hatalı': 'Email ou mot de passe incorrect',
  'Şifre sıfırlama e-postası gönderildi': 'Email de réinitialisation de mot de passe envoyé',
  'E-posta gönderilemedi': 'L\'email n\'a pas pu être envoyé',
  'Üye Ol': 'S\'Inscrire',
  'Üye Değil Misiniz?': 'Vous n\'êtes pas membre?',
  'Şimdi Üye Ol': 'S\'Inscrire Maintenant',
  'Misafir Kullanıcı': 'Utilisateur Invité',
  'Hızlı Sipariş': 'Commande Rapide',
  'Misafir Olarak Sipariş Verin': 'Commander en tant qu\'Invité',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Sélectionnez rapidement vos produits et créez votre commande sans vous connecter',
  'Giriş yapmadan sipariş oluşturun': 'Créer une commande sans se connecter',
  'Anında Erişim': 'Accès Instantané',
  'Tüm ürünlere anında erişim': 'Accès instantané à tous les produits',
  'Güvenli İşlem': 'Transaction Sécurisée',
  'SSL korumalı güvenli sipariş': 'Commande sécurisée protégée par SSL',
  'Misafir Olarak Sipariş Oluştur': 'Créer une Commande en tant qu\'Invité',
  'İpucu:': 'Conseil:',
  'Daha fazla özellik için üye olun': 'Inscrivez-vous pour plus de fonctionnalités',
  'Ücretsiz': 'Gratuit',
  'Hızlı': 'Rapide',
  'Güvenli': 'Sécurisé',
  'bayilikSozlesme': 'J\'ai lu et j\'accepte les termes et conditions de partenariat INVAMED.',
  'geri': 'Retour',
  'basvuruGonder': 'Soumettre la Candidature',
  'ileri': 'Suivant',
  'sozlesmeGonderildi': 'Contrat Envoyé à Votre Email!',
  'sozlesmeDesc': 'Veuillez télécharger le Contrat de Partenariat INVAMED et les documents requis envoyés à votre adresse email ci-dessous.',
  'tamamla': 'Finaliser la Candidature',
  'basvuruAlindi': 'Votre Candidature a Été Reçue!',
  'basvuruAlindiDesc': 'L\'équipe INVAMED examinera votre candidature et vous contactera dans les plus brefs délais.',
  'Başvuru Durumu': 'Statut de la candidature',
  'Başvurunuz onay sürecindedir': 'Votre candidature est en cours d\'examen',
  'sifreSifirla': 'Réinitialiser le Mot de Passe',
  'sifreSifirlaDesc': 'Entrez votre adresse email enregistrée et nous vous enverrons les instructions pour réinitialiser votre mot de passe.',
  'gonder': 'Envoyer',
  'talimatGonderildi': 'Instructions Envoyées',
  'sentDesc': 'Les instructions de réinitialisation du mot de passe ont été envoyées à <b>{email}</b>. Veuillez vérifier votre email.',
  'helpTitle': 'Comment puis-je me connecter?',
  'helpList': [
    'Pour vous connecter au panneau distributeur INVAMED, entrez votre adresse email enregistrée et votre mot de passe.',
    'Pour vous connecter avec l\'utilisateur démo:',
    'Si vous avez oublié votre mot de passe, utilisez le lien "Mot de Passe Oublié" pour demander une réinitialisation.',
    'Si vous avez des problèmes de connexion, assurez-vous que votre email et mot de passe sont corrects. Si le problème persiste, contactez notre équipe de support.'
  ],
  'partnerlikSozlesmeTitle': 'Accord de Partenariat INVAMED et Conditions',
  'partnerlikSozlesmeText': `1. DISPOSITIONS GÉNÉRALES

Cet accord est conclu entre INVAMED (ci-après dénommé "Société") et le candidat partenaire (ci-après dénommé "Partenaire") dans le but de coopération dans la vente de dispositifs médicaux et d'équipements.

2. CONDITIONS DE PARTENARIAT

2.1. Le Partenaire doit avoir l'autorité légale pour la vente de dispositifs médicaux.
2.2. Le Partenaire doit être une organisation opérant dans le secteur de la santé.
2.3. Le Partenaire doit avoir les licences et certificats nécessaires.
2.4. Le Partenaire doit être financièrement fiable.

3. OBLIGATIONS DES PARTIES

Obligations de la Société:
3.1. Fournir des produits et services de qualité
3.2. Fournir un support technique
3.3. Fournir une formation et des informations
3.4. Être transparent sur les prix

Obligations du Partenaire:
3.1. Stocker les produits dans des conditions appropriées
3.2. Fournir un service client de qualité
3.3. Respecter les réglementations légales
3.4. Protéger la marque de l'entreprise

4. FIXATION DES PRIX ET PAIEMENT

4.1. Les prix sont déterminés par la Société
4.2. Le Partenaire est tenu de maintenir les prix déterminés
4.3. Les conditions de paiement sont déterminées séparément
4.4. Les taux de commission peuvent varier selon les performances

5. CONFIDENTIALITÉ ET SÉCURITÉ

5.1. Les parties sont tenues de protéger les informations confidentielles de chacune
5.2. Les informations client doivent être gardées confidentielles
5.3. Les normes de sécurité des données doivent être respectées

6. DURÉE ET RÉSILIATION DE L'ACCORD

6.1. Cet accord est valable pour 1 an
6.2. Peut être prolongé par accord mutuel
6.3. Peut être résilié avec un préavis de 30 jours
6.4. Peut être résilié immédiatement en cas de violation grave

7. RÉSOLUTION DES LITIGES

7.1. Les litiges sont principalement tentés d'être résolus par négociation
7.2. Les tribunaux de la République de Turquie sont autorisés pour les cas non résolus

8. EFFICACITÉ

Cet accord a été lu, compris et accepté par les parties.`,
  'partnerlikSozlesmeOnay': 'J\'ai lu, compris et accepté l\'Accord de Partenariat INVAMED et les Conditions ci-dessus. Je déclare que j\'accepte tous les articles de cet accord et que je remplirai mes obligations.',
  'sozlesmeyiGoruntule': 'Voir l\'Accord',
  'sozlesmeyiKapat': 'Fermer',
  'Ürün': 'Produit',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Sélectionnez des produits dans la liste pour ajouter au panier',
  'Etiketler': 'Étiquettes',
  'Öncelikli': 'Priorité',
  'Kapat': 'Fermer',
  'globalPartnersTitle': 'Collaboration avec 30,000 Partenaires dans le Monde',
  'globalPartnersDesc': 'Notre vaste réseau mondial de 30,000 partenaires stimule l\'innovation partagée, l\'échange de connaissances et le succès mutuel. En travaillant ensemble, nous élargissons continuellement les frontières des soins aux patients.',
  'Yardım': 'Aide',
  'dil': 'Langue',
  'Connect Free!': 'Connexion gratuite !',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Découvrez nos produits les plus populaires',
  'Tüm Kategoriler': 'Toutes les catégories',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 produits affichés (Total : 8000+)',
  'Tüm Ürünleri Gör →': 'Voir tous les produits →',
  'Detaylar': 'Détails',
  'Sipariş Ver': 'Commander',
  'Giriş Yap': 'Connexion',
  'Hesabınıza giriş yapın': 'Connectez-vous à votre compte',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Ce site est protégé par reCAPTCHA et la politique de confidentialité et les conditions d\'utilisation de Google s\'appliquent.',
  'Ürün Kataloğumuz': 'Notre catalogue de produits',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'Nous proposons plus de 8000 produits',
  '1,3B': '1,3K',
  'Partner': 'Partenaire',
  '8,4M': '8,4M',
  'Toplam Üretim': 'Production totale',
  '23': '23',
  'Branş': 'Branche',
  '27,5B': '27,5K',
  'Toplam Sipariş': 'Commandes totales',
  'Connect Now': 'Connectez maintenant',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Inscrivez-vous gratuitement pour accéder à toutes les informations en un seul endroit.',
  'Ürün Detayları': 'Détails du produit',
  'Kapat': 'Fermer',
  'Yükleniyor...': 'Chargement...',
  'Hata': 'Erreur',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} produits affichés (Total : 8000+)',
  'Şehir Seçimi': 'Sélection de ville',
  'Firma / Sağlık Profesyoneli': 'Entreprise / Professionnel de santé',
  'Yetkili Kişi': 'Personne autorisée',
  'Telefon': 'Téléphone',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Informations de base',
  'Ek Bilgiler': 'Informations supplémentaires',
  'Faaliyet Alanı / Sektör': 'Domaine d\'activité / Secteur',
  'Ülke Seçimi': 'Sélection de pays',
  'Ülke adı veya kodu ara...': 'Rechercher nom ou code de pays...',
  'region.Avrupa': 'Europe',
  'region.Amerika': 'Amérique',
  'region.Asya': 'Asie',
  'region.Afrika': 'Afrique',
  'region.Okyanusya': 'Océanie',
  'region.Diğer': 'Autre',
  'country.TR': 'Turquie',
  'country.US': 'États-Unis',
  'country.DE': 'Allemagne',
  'country.FR': 'France',
  'country.GB': 'Royaume-Uni',
  'country.IT': 'Italie',
  'country.ES': 'Espagne',
  'country.RU': 'Russie',
  'country.CN': 'Chine',
  'country.JP': 'Japon',
  'country.KR': 'Corée du Sud',
  'country.IN': 'Inde',
  'country.BR': 'Brésil',
  'country.CA': 'Canada',
  'country.AU': 'Australie',
  'Ticaret Sicil No': 'Numéro de registre du commerce',

  'country.TR': 'Turquie',
  'country.AL': 'Albanie',
  'country.DE': 'Allemagne',
  'country.AD': 'Andorre',
  'country.AT': 'Autriche',
  'country.BY': 'Biélorussie',
  'country.BE': 'Belgique',
  'country.BA': 'Bosnie-Herzégovine',
  'country.BG': 'Bulgarie',
  'country.CZ': 'République tchèque',
  'country.DK': 'Danemark',
  'country.EE': 'Estonie',
  'country.FO': 'Îles Féroé',
  'country.FI': 'Finlande',
  'country.FR': 'France',
  'country.GI': 'Gibraltar',
  'country.GR': 'Grèce',
  'country.GG': 'Guernesey',
  'country.HR': 'Croatie',
  'country.NL': 'Pays-Bas',
  'country.IE': 'Irlande',
  'country.ES': 'Espagne',
  'country.SE': 'Suède',
  'country.CH': 'Suisse',
  'country.IT': 'Italie',
  'country.IS': 'Islande',
  'country.JE': 'Jersey',
  'country.ME': 'Monténégro',
  'country.LV': 'Lettonie',
  'country.LI': 'Liechtenstein',
  'country.LT': 'Lituanie',
  'country.LU': 'Luxembourg',
  'country.HU': 'Hongrie',
  'country.MT': 'Malte',
  'country.IM': 'Île de Man',
  'country.MD': 'Moldavie',
  'country.MC': 'Monaco',
  'country.MK': 'Macédoine du Nord',
  'country.NO': 'Norvège',
  'country.PL': 'Pologne',
  'country.PT': 'Portugal',
  'country.RO': 'Roumanie',
  'country.RU': 'Russie',
  'country.SM': 'Saint-Marin',
  'country.RS': 'Serbie',
  'country.SK': 'Slovaquie',
  'country.SI': 'Slovénie',
  'country.SJ': 'Svalbard et Jan Mayen',
  'country.UA': 'Ukraine',
  'country.GB': 'Royaume-Uni',
  'country.VA': 'Vatican',
  'country.AX': 'Îles Åland',
  'country.US': 'États-Unis',
  'country.AS': 'Samoa américaines',
  'country.AI': 'Anguilla',
  'country.AG': 'Antigua-et-Barbuda',
  'country.AR': 'Argentine',
  'country.AW': 'Aruba',
  'country.BS': 'Bahamas',
  'country.BB': 'Barbade',
  'country.BZ': 'Belize',
  'country.BM': 'Bermudes',
  'country.BO': 'Bolivie',
  'country.BR': 'Brésil',
  'country.VG': 'Îles Vierges britanniques',
  'country.CA': 'Canada',
  'country.KY': 'Îles Caïmans',
  'country.CL': 'Chili',
  'country.CO': 'Colombie',
  'country.CR': 'Costa Rica',
  'country.CU': 'Cuba',
  'country.CW': 'Curaçao',
  'country.DM': 'Dominique',
  'country.DO': 'République dominicaine',
  'country.EC': 'Équateur',
  'country.SV': 'El Salvador',
  'country.FK': 'Îles Malouines',
  'country.GF': 'Guyane française',
  'country.GD': 'Grenade',
  'country.GL': 'Groenland',
  'country.GP': 'Guadeloupe',
  'country.GT': 'Guatemala',
  'country.GY': 'Guyana',
  'country.HT': 'Haïti',
  'country.HN': 'Honduras',
  'country.JM': 'Jamaïque',
  'country.MQ': 'Martinique',
  'country.MX': 'Mexique',
  'country.MS': 'Montserrat',
  'country.NI': 'Nicaragua',
  'country.PA': 'Panama',
  'country.PY': 'Paraguay',
  'country.PE': 'Pérou',
  'country.PR': 'Porto Rico',
  'country.BL': 'Saint-Barthélemy',
  'country.KN': 'Saint-Kitts-et-Nevis',
  'country.LC': 'Sainte-Lucie',
  'country.MF': 'Saint-Martin',
  'country.PM': 'Saint-Pierre-et-Miquelon',
  'country.VC': 'Saint-Vincent-et-les-Grenadines',
  'country.SX': 'Sint Maarten',
  'country.SR': 'Suriname',
  'country.TT': 'Trinité-et-Tobago',
  'country.TC': 'Îles Turques-et-Caïques',
  'country.UY': 'Uruguay',
  'country.VE': 'Venezuela',
  'country.VI': 'Îles Vierges des États-Unis',
  'country.AF': 'Afghanistan',
  'country.AZ': 'Azerbaïdjan',
  'country.BH': 'Bahreïn',
  'country.BD': 'Bangladesh',
  'country.AE': 'Émirats arabes unis',
  'country.BN': 'Brunei',
  'country.BT': 'Bhoutan',
  'country.CN': 'Chine',
  'country.TL': 'Timor oriental',
  'country.ID': 'Indonésie',
  'country.AM': 'Arménie',
  'country.PH': 'Philippines',
  'country.PS': 'Palestine',
  'country.GE': 'Géorgie',
  'country.KR': 'Corée du Sud',
  'country.IN': 'Inde',
  'country.HK': 'Hong Kong',
  'country.IQ': 'Irak',
  'country.IR': 'Iran',
  'country.IL': 'Israël',
  'country.JP': 'Japon',
  'country.KH': 'Cambodge',
  'country.QA': 'Qatar',
  'country.KZ': 'Kazakhstan',
  'country.KG': 'Kirghizistan',
  'country.CY': 'Chypre',
  'country.KW': 'Koweït',
  'country.KP': 'Corée du Nord',
  'country.LA': 'Laos',
  'country.LB': 'Liban',
  'country.MO': 'Macao',
  'country.MV': 'Maldives',
  'country.MY': 'Malaisie',
  'country.MM': 'Myanmar',
  'country.MN': 'Mongolie',
  'country.NP': 'Népal',
  'country.UZ': 'Ouzbékistan',
  'country.PK': 'Pakistan',
  'country.SG': 'Singapour',
  'country.LK': 'Sri Lanka',
  'country.SY': 'Syrie',
  'country.SA': 'Arabie saoudite',
  'country.TJ': 'Tadjikistan',
  'country.TH': 'Thaïlande',
  'country.TW': 'Taïwan',
  'country.TM': 'Turkménistan',
  'country.OM': 'Oman',
  'country.JO': 'Jordanie',
  'country.VN': 'Vietnam',
  'country.YE': 'Yémen',
  'country.DZ': 'Algérie',
  'country.AO': 'Angola',
  'country.BJ': 'Bénin',
  'country.BW': 'Botswana',
  'country.BF': 'Burkina Faso',
  'country.BI': 'Burundi',
  'country.CV': 'Cap-Vert',
  'country.CM': 'Cameroun',
  'country.CF': 'République centrafricaine',
  'country.TD': 'Tchad',
  'country.KM': 'Comores',
  'country.CG': 'République du Congo',
  'country.CD': 'République démocratique du Congo',
  'country.CI': 'Côte d\'Ivoire',
  'country.DJ': 'Djibouti',
  'country.EG': 'Égypte',
  'country.GQ': 'Guinée équatoriale',
  'country.ER': 'Érythrée',
  'country.SZ': 'Eswatini',
  'country.ET': 'Éthiopie',
  'country.GA': 'Gabon',
  'country.GM': 'Gambie',
  'country.GH': 'Ghana',
  'country.GN': 'Guinée',
  'country.GW': 'Guinée-Bissau',
  'country.KE': 'Kenya',
  'country.LS': 'Lesotho',
  'country.LR': 'Libéria',
  'country.LY': 'Libye',
  'country.MG': 'Madagascar',
  'country.MW': 'Malawi',
  'country.ML': 'Mali',
  'country.MR': 'Mauritanie',
  'country.MU': 'Maurice',
  'country.YT': 'Mayotte',
  'country.MA': 'Maroc',
  'country.MZ': 'Mozambique',
  'country.NA': 'Namibie',
  'country.NE': 'Niger',
  'country.NG': 'Nigeria',
  'country.RE': 'Réunion',
  'country.RW': 'Rwanda',
  'country.SH': 'Sainte-Hélène',
  'country.ST': 'São Tomé-et-Principe',
  'country.SN': 'Sénégal',
  'country.SC': 'Seychelles',
  'country.SL': 'Sierra Leone',
  'country.SO': 'Somalie',
  'country.ZA': 'Afrique du Sud',
  'country.SS': 'Soudan du Sud',
  'country.SD': 'Soudan',
  'country.TZ': 'Tanzanie',
  'country.TG': 'Togo',
  'country.TN': 'Tunisie',
  'country.UG': 'Ouganda',
  'country.EH': 'Sahara occidental',
  'country.ZM': 'Zambie',
  'country.ZW': 'Zimbabwe',
  'country.AU': 'Australie',
  'country.CX': 'Île Christmas',
  'country.CC': 'Îles Cocos',
  'country.CK': 'Îles Cook',
  'country.FJ': 'Fidji',
  'country.PF': 'Polynésie française',
  'country.GU': 'Guam',
  'country.HM': 'Îles Heard et McDonald',
  'country.KI': 'Kiribati',
  'country.MH': 'Îles Marshall',
  'country.FM': 'Micronésie',
  'country.NR': 'Nauru',
  'country.NC': 'Nouvelle-Calédonie',
  'country.NZ': 'Nouvelle-Zélande',
  'country.NU': 'Niue',
  'country.NF': 'Île Norfolk',
  'country.MP': 'Îles Mariannes du Nord',
  'country.PW': 'Palaos',
  'country.PG': 'Papouasie-Nouvelle-Guinée',
  'country.PN': 'Îles Pitcairn',
  'country.WS': 'Samoa',
  'country.SB': 'Îles Salomon',
  'country.TK': 'Tokelau',
  'country.TO': 'Tonga',
  'country.TV': 'Tuvalu',
  'country.VU': 'Vanuatu',
  'country.WF': 'Wallis-et-Futuna',
  'country.AQ': 'Antarctique',
  'country.BV': 'Île Bouvet',
  'country.IO': 'Territoire britannique de l océan Indien',
  'country.TF': 'Terres australes françaises',
  'country.GS': 'Géorgie du Sud et les îles Sandwich du Sud',
}; 